import { render, staticRenderFns } from "./ReportCardView.vue?vue&type=template&id=42e56e1a"
import script from "./ReportCardView.vue?vue&type=script&lang=ts"
export * from "./ReportCardView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ReportCardDetail: require('/app/components/Run/ReportCard/ReportCardDetail.vue').default,CheckLayoutWrapper: require('/app/components/analyzer/CheckLayoutWrapper.vue').default})
